// src/components/Navbar.jsx
import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useCart } from "../Context/Cartcontext";
import { FaShoppingCart } from "react-icons/fa";
import { useAuth } from "../Context/AuthContext";
import { searchCourses } from "../Services/Api"; // <-- your search API

export default function Navbar() {
  const { cartItems } = useCart();
  const { user, authLoading, logout } = useAuth();
  const navigate = useNavigate();
  // const [dropdownOpen, setDropdownOpen] = useState(false);

  const [showMenu, setShowMenu] = useState(false);

  // 🔍 Search states
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  const handleLogout = async () => {
    try {
      await logout();
      setShowMenu(false);
      navigate("/login");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  // Debounced search
  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      if (query.trim().length > 1) {
        try {
          const res = await searchCourses(query);
          setResults(res);
        } catch (err) {
          console.error("Search failed", err);
        }
      } else {
        setResults([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [query]);

  return (
    <>
      {/* Top Bar */}
      <div
        className="bg-purple-700 text-white text-sm px-8 py-2 flex flex-col sm:flex-row justify-between items-center"
        style={{ backgroundColor: "rgb(93, 76, 207)" }}
      >
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8">

          <span className="flex items-center">
            <i className="fas fa-building mr-2 text-white"></i>
            Logistics Sector Skill Council
          </span>

          <span className="flex items-center">
            <i className="fas fa-map-marker-alt mr-2 text-white"></i> 480 A,7th
            floor,Khivraj Complex II, Nandhanam.
          </span>
          {/* <span className="flex items-center">
            <i className="fas fa-envelope mr-2 text-white"></i>{" "}
            solutions@lsc-india.com
          </span> */}
        </div>






        <div className="flex items-center mt-2 sm:mt-0 space-x-3">
          <a
            href="https://www.facebook.com/LSCIndiaOfficial"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Facebook page"
          >
            <i className="fab fa-facebook-f bg-white text-pink-500 rounded-full p-2 px-3 text-sm"></i>
          </a>
          <a
            href="https://x.com/LogisticsSSC"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Twitter page"
          >
            <i className="fab fa-twitter bg-white text-pink-500 rounded-full p-2 px-3 text-sm"></i>
          </a>
          <a
            href="https://www.instagram.com/logisticssector_skillcouncil/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Instagram page"
          >
            <i className="fab fa-instagram bg-white text-pink-500 rounded-full p-2 px-3 text-sm"></i>
          </a>
          <a
            href="https://www.linkedin.com/company/logistics-sector-skill-council/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our LinkedIn page"
          >
            <i className="fab fa-linkedin-in bg-white text-pink-500 rounded-full p-2 px-3 text-sm"></i>
          </a>
          <a
            href="https://www.youtube.com/@logisticsSSC/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our LinkedIn page"
          >
            <i className="fab fa-youtube bg-white text-pink-500 rounded-full p-2 px-3 text-sm"></i>
          </a>
        </div>
      </div>


      <header className="bg-white shadow-md px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4 flex-wrap md:flex-nowrap">
          <div className="flex items-center flex-shrink-0">
            <NavLink to="/">
              <img
                src="/images/LSClogo.png"
                alt="LSC Logo"
                className="h-[58px] w-auto"
              />
            </NavLink>
          </div>
          <nav className="flex flex-1 justify-start space-x-6 text-gray-700 font-medium">

            <NavLink to="/" className={({ isActive }) => isActive ? "text-blue-600 font-semibold" : "hover:text-blue-600"} >
              Home
            </NavLink>

            <NavLink to="/courses" className={({ isActive }) => isActive ? "text-blue-600 font-semibold" : "hover:text-blue-600"} >
              Courses
            </NavLink>


 
            {/* Programmes Dropdown */}
            <div className="relative group">
              <div className="cursor-pointer hover:text-blue-600 ">
                Programmes
              </div>

              {/* DROPDOWN BOX */}
              <div
                className="
                  absolute top-full left-0 w-64 bg-white border border-gray-200 
                  shadow-lg rounded-md z-50

                  opacity-0 pointer-events-none
                  group-hover:opacity-100 group-hover:pointer-events-auto
                  transition-all duration-200
                "
              >
                {/* <a
                  href="https://edc.lsc-india.org/imdg_course/info.php"
                  className="block px-4 py-2 hover:bg-blue-100"
                  target="_blank"
                >
                  <span style={{ fontSize: "11px" }}>IMDG Training</span>
                </a>
                <hr style={{ color: "rgb(93, 76, 207)" }} /> */}

                <a
                  href="https://mylsc.in/wa/imdg_offline/info.php"
                  className="block px-4 py-2 hover:bg-blue-100"
                  target="_blank"
                >
                  <span style={{ fontSize: "11px" }}>IMDG 42-24 Dangerous Goods Classroom Code Training</span>
                </a>
                <hr />

                <a
                  href="https://edc.lsc-india.org/Forklift/details.php"
                  className="block px-4 py-2 hover:bg-blue-100"
                  target="_blank"
                >
                  <span style={{ fontSize: "11px" }}>Forklift Operator Training Program</span>
                </a>
              </div>
            </div>

          </nav>

          {/* Search (Center) */}
          <div className="relative w-full sm:w-auto order-3 sm:order-none my-3 sm:my-0">
            <input
              type="text"
              placeholder="Search courses..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="
                px-4 py-2 pl-10
                w-full
                sm:w-72 md:w-80 lg:w-96
                rounded-lg border border-blue-300
                focus:outline-none focus:ring-2 focus:ring-blue-500
              "
            />

            <svg
              className="absolute left-3 top-2.5 w-5 h-5 text-blue-400"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 13.65z"
              />
            </svg>
            {/* Results Dropdown */}
            {/* Results Dropdown */}
            {results.length > 0 && (
              <ul className="absolute left-0 mt-2 w-full bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto z-50">
                {results.map((course) => (
                  <li
                    key={course.id}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer bg-blue-50 m-3 rounded-md"
                    onClick={() => {
                      navigate(`/about-course/${course.id}`);
                      setQuery("");
                      setResults([]);
                    }}
                  >
                    {course.course_name}
                  </li>
                ))}
              </ul>
            )}

            {/* No Results */}
            {query.length > 2 && results.length === 0 && (
              <ul className="absolute left-0 mt-2 w-full bg-white border rounded-lg shadow-lg z-50">
                <li className="px-4 py-3 text-gray-500 text-center">
                  ❌ No courses found
                </li>
              </ul>
            )}

          </div>

          {/* Right Side (User + Cart) */}
          <div className="flex gap-3 items-center">
            {authLoading ? (
              <div className="px-4 py-2 text-gray-700">...</div>
            ) : user ? (
              <>
                <span className="font-medium text-gray-800">
                  👋 {user.firstname || user.username}
                </span>

                {/* Dropdown */}
                <div className="relative">
                  <button
                    onClick={() => setShowMenu(!showMenu)}
                    className="w-10 h-10 rounded-full text-white font-bold flex items-center justify-center ml-3"
                    style={{ backgroundColor: "#5D4CCF" }}
                  >
                    {user.firstname?.charAt(0).toUpperCase() ||
                      user.username?.charAt(0).toUpperCase()}
                  </button>

                  {showMenu && (
                    <div className="absolute right-0 mt-2 w-40 bg-white border rounded shadow z-50">
                      <ul className="text-gray-700">
                        <li
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                          onClick={() => {
                            navigate("/Mycourse");
                            setShowMenu(false);
                          }}
                        >
                          My Course
                        </li>
                        <li
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-600"
                          onClick={() => {
                            handleLogout();
                            setShowMenu(false);
                          }}
                        >
                          Logout
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <NavLink
                  to="/login"
                  className="px-4 py-2 rounded-md border border-blue-600 text-blue-600 font-medium hover:bg-blue-600 hover:text-white transition"
                >
                  Login
                </NavLink>
                <NavLink
                  to="/register"
                  className="px-4 py-2 rounded-md text-white font-medium hover:bg-blue-700 transition"
                  style={{ backgroundColor: "#5D4CCF" }}
                >
                  Sign Up
                </NavLink>
              </>
            )}

            <div className="relative">
              <NavLink to="/cart" className="text-black text-[19px] relative">
                <FaShoppingCart />

                {cartItems.length > 0 && (
                  <span className="absolute -top-2 -right-2 bg-purple-600 text-white rounded-full text-[10px] px-1.5 font-bold">
                    {cartItems.length}
                  </span>
                )}
              </NavLink>
            </div>


          </div>
        </div>
      </header>
    </>
  );
}
